var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brain 1",
    clipPath: "url(#clip0_15953_2255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0681 28.8037C9.28099 28.8037 6.21094 31.8737 6.21094 35.6609C6.21094 39.4481 9.28099 42.518 13.0681 42.518C13.8695 42.518 14.6389 42.3804 15.3538 42.1278",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.81521 32.4713C3.75322 30.9938 1.64062 27.8597 1.64062 24.2322C1.64062 21.4626 2.87201 18.9808 4.81717 17.3042",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.8909 17.1197C4.28374 16.2121 3.92969 15.1207 3.92969 13.9467C3.92969 10.7908 6.48806 8.23242 9.64397 8.23242C10.9306 8.23242 12.118 8.65766 13.0731 9.37528",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.6136 9.52481C13.2651 8.78612 13.0703 7.9607 13.0703 7.08977C13.0703 3.93387 15.6287 1.37549 18.7846 1.37549C21.9405 1.37549 24.4989 3.93387 24.4989 7.08977V42.5183",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.3594 42.5181C15.3594 45.0429 17.4061 47.0895 19.9308 47.0895C22.4556 47.0895 24.5022 45.0429 24.5022 42.5181",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.5 12.8037C24.5 16.5908 27.5699 19.6609 31.3571 19.6609",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.9263 28.8037C39.7135 28.8037 42.7835 31.8737 42.7835 35.6609C42.7835 39.4481 39.7135 42.518 35.9263 42.518C35.125 42.518 34.3556 42.3804 33.6406 42.1278",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M42.1797 32.4713C45.2416 30.9938 47.3543 27.8597 47.3543 24.2322C47.3543 21.4626 46.1228 18.9808 44.1776 17.3042",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M44.1119 17.1197C44.7189 16.2121 45.073 15.1207 45.073 13.9467C45.073 10.7908 42.5146 8.23242 39.3587 8.23242C38.0721 8.23242 36.8847 8.65766 35.9297 9.37528",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M24.5 7.08977C24.5 3.93387 27.0584 1.37549 30.2143 1.37549C33.3702 1.37549 35.9286 3.93387 35.9286 7.08977C35.9286 7.9607 35.7338 8.78612 35.3853 9.52481",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.6429 42.5181C33.6429 45.0429 31.5962 47.0895 29.0714 47.0895C26.5466 47.0895 24.5 45.0429 24.5 42.5181",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15953_2255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.232422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.7605cc3fcda4044eaa0f06f08d17ec2f.svg";
export { ForwardRef as ReactComponent };